// CSS Modules - component class name: RFQForm__

<template>
  <form :class="$style.container">
    <h1>{{ config.intro.title }}</h1>
    <p>{{ config.intro.text }}</p>
    <div class="columns">
      <div class="column">
        <FormInput
          v-model.trim="$v.formData.name.$model"
          :label="config.labels.name.label"
          :boldLabel="true"
          :errorMessage="config.labels.name.errorMessage"
          :error="$v.formData.name.$error && $v.$dirty && isSubmitted"
          :originalValue="
            previousData.name && previousData.name !== ''
              ? previousData.name
              : null
          "
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
      <div class="column">
        <FormInput
          v-model.trim="$v.formData.company.$model"
          :label="config.labels.company.label"
          :boldLabel="true"
          :errorMessage="config.labels.company.errorMessage"
          :error="$v.formData.company.$error && $v.$dirty && isSubmitted"
          :originalValue="
            previousData.company && previousData.company !== ''
              ? previousData.company
              : null
          "
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <FormInput
          v-model="formData.customer"
          :label="config.labels.customer.label"
          :optionalLabel="config.labels.customer.optionLabel"
          :error="false"
          :originalValue="
            previousData.customer && previousData.customer !== ''
              ? previousData.customer
              : null
          "
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
      <div class="column">
        <FormInput
          v-model="formData.street"
          :label="config.labels.street.label"
          :optionalLabel="config.labels.street.optionLabel"
          :error="false"
          :originalValue="
            previousData.street && previousData.street !== ''
              ? previousData.street
              : null
          "
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <FormInput
          v-model.trim="$v.formData.zipCity.$model"
          :label="config.labels.zipCity.label"
          :boldLabel="true"
          :errorMessage="config.labels.zipCity.errorMessage"
          :error="$v.formData.zipCity.$error && $v.$dirty && isSubmitted"
          :originalValue="
            previousData.zipCity && previousData.zipCity !== ''
              ? previousData.zipCity
              : null
          "
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
      <div class="column">
        <FormSelect
          v-model.trim="$v.formData.country.$model"
          :label="config.labels.country.label"
          :errorMessage="config.labels.country.errorMessage"
          :error="$v.formData.country.$error && $v.$dirty && isSubmitted"
          :options="config.countryOptions"
          :initialOption="config.initialCountryOption"
        />
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <FormInput
          v-model="formData.phone"
          :label="config.labels.phone.label"
          :optionalLabel="config.labels.phone.optionLabel"
          :error="false"
          :originalValue="
            previousData.phone && previousData.phone !== ''
              ? previousData.phone
              : null
          "
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
      <div class="column">
        <FormInput
          v-model.trim="$v.formData.email.$model"
          :label="config.labels.email.label"
          :boldLabel="true"
          :errorMessage="config.labels.email.errorMessage"
          :error="$v.formData.email.$error && $v.$dirty && isSubmitted"
          :originalValue="
            previousData.email && previousData.email !== ''
              ? previousData.email
              : null
          "
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
    </div>
    <div :class="$style.articleDataText">
      <b>{{ config.overview.title }}</b>
      <p>{{ config.overview.text }}</p>
    </div>
    <div v-if="formData.articleData && formData.articleData.length !== 0">
      <div
        v-for="(item, outerIndex) in formData.articleData"
        :key="outerIndex"
        :class="$style.articleData"
      >
        <b>{{ item.productTypes }}</b>
        <div
          v-for="(article, index) in item.articles"
          :key="index"
          class="columns is-mobile"
        >
          <div class="column is-half">
            {{ config.labels.articleData.articleNumber }}: {{ article.number }}
            <div
              :class="$style.infoPopper"
              v-tippy="{
                theme: 'wika light tooltip tooltip-bottom',
                interactive: true,
                reactive: true,
                placement: 'bottom',
                flip: false,
                animation: 'fade',
                duration: [200, 600],
                animateFill: false,
                arrow: true,
                distance: 7,
                zIndex: 10000,
                html: '#infoCircle',
                trigger: isMobileDevice ? 'click' : 'mouseenter focus'
              }"
              ref="tippy"
              @init="initTippy"
            >
              <i class="fas fa-file-alt"></i>
              <div id="infoCircle" v-html="article.detailText"></div>
            </div>
            <a
              @click.prevent.stop="removeItem(index, outerIndex)"
              :class="$style.trash"
              :title="config.trashTitle"
            >
              <i class="fas fa-trash-alt"></i>
            </a>
          </div>
          <div class="column is-half">
            <FormInput
              v-model="article.total"
              type="number"
              maxlength="4"
              min="1"
              :label="config.labels.articleData.articleTotal + ':'"
            />
          </div>
        </div>
      </div>
    </div>
    <p v-else :class="$style.warning">
      <span>{{ config.warning.title }}</span
      >{{ config.warning.text }}
    </p>
    <div class="columns">
      <div class="column">
        <FormTextarea
          v-model="formData.message"
          :label="config.labels.message.label"
          :optionalLabel="config.labels.message.optionLabel"
          :error="false"
          :rows="5"
          :columns="20"
        />
      </div>
    </div>
    <div class="columns">
      <div class="column has-text-right-tablet">
        <Button
          colour="blue"
          text="Senden"
          type="submit"
          :isForm="true"
          @close="handleSubmit"
        >
        </Button>
      </div>
    </div>
    <div :class="$style.serverError" v-if="serverError">
      {{ config.serverErrorMessage }}
    </div>
    <ReCaptcha :executeSwitch="executeSwitch" :submit="submit" />
  </form>
</template>

<script>
import { email, required } from "vuelidate/lib/validators";
import ReCaptcha from "../ReCaptcha/ReCaptcha";
import FormInput from "../FormInput/FormInput";
import FormSelect from "../FormSelect/FormSelect";
import FormTextarea from "../FormTextarea/FormTextarea";
import Button from "../Button/Button";
import * as Storage from "../../shared/Storage";
import { isMobile } from "mobile-device-detect";
import StorageKeys from "../../globals/constants/storageKeys";
import submitRFQForm from "../../xhr/submitRFQForm";

const noPlaceholderValue = value =>
  value.label ? value.label.indexOf("...") === -1 : value.indexOf("...") === -1;

export default {
  name: "RFQForm",
  components: {
    ReCaptcha,
    Button,
    FormInput,
    FormSelect,
    FormTextarea
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      formData: {
        name: "",
        company: "",
        customer: "",
        street: "",
        zipCity: "",
        country: "",
        phone: "",
        email: "",
        articleData: null,
        message: "",
        domain: "",
        pageUrl: "",
        language: "",
        token: ""
      },
      previousData: {},
      isSubmitted: false,
      executeSwitch: false,
      formSubmitSwitch: false,
      showThankyou: false,
      serverError: false,
      isMobileDevice: isMobile
    };
  },
  validations: {
    formData: {
      name: {
        required
      },
      company: {
        required
      },
      zipCity: {
        required
      },
      country: {
        required,
        noPlaceholderValue
      },
      email: {
        required,
        email
      }
    }
  },
  mounted() {
    this.checkLocalStorage();
    if (this.config.initialCountryOption) {
      this.formData.country = this.config.initialCountryOption;
    }
  },
  methods: {
    checkLocalStorage() {
      this.formData.articleData = Storage.getLocalStorage(
        StorageKeys.ARTICLE_DATA,
        true
      );
    },
    initTippy(tippy) {
      tippy.popper.id = "infoPopper";
    },
    removeItem(index, outerIndex) {
      if (this.formData.articleData[outerIndex].articles.length > 1) {
        this.formData.articleData[outerIndex].articles.splice(index, 1);
      } else {
        this.formData.articleData.splice(outerIndex, 1);
      }
      Storage.setLocalStorage(
        StorageKeys.ARTICLE_DATA,
        this.formData.articleData,
        true
      );
    },
    handleSubmit() {
      this.serverError = false;
      this.$v.$touch();
      this.isSubmitted = true;
      this.formSubmitSwitch = !this.formSubmitSwitch;
      if (!this.$v.$invalid) {
        this.executeSwitch = !this.executeSwitch;
        //this.submit();
      } else {
        this.previousData = JSON.parse(JSON.stringify(this.formData));
      }
    },
    submit(token) {
      const formData = {
        ...this.formData,
        ...this.config.mailData,
        formId: this.config.formId,
        "mwf-formElement-sequence":
          "name,company,customer,street,zipCity,country,phone,email,articleData,message",
        "mwf-formLabel-name": "Name",
        "mwf-formLabel-company": "Company",
        "mwf-formLabel-customer": "Customer",
        "mwf-formLabel-street": "Street",
        "mwf-formLabel-zipCity": "ZIP code / City",
        "mwf-formLabel-country": "Country",
        "mwf-formLabel-phone": "Phone",
        "mwf-formLabel-email": "E-Mail",
        "mwf-formLabel-articleData": "Article data",
        "mwf-formLabel-message": "Message",
        domain: window.location.origin,
        pageUrl: window.location.pathname,
        language: window.currentLanguage
      };

      // Process articleData
      if (formData.articleData) {
        formData.articleData = formData.articleData
          .map(x =>
            x.articles.map(
              article =>
                `${article.number} - ${x.productTypes} - ${article.total}`
            )
          )
          .flatMap(x => x)
          .join("\n");
      }
      // Add empty attachments if missing
      if (!formData.attachments) {
        formData.attachments = [];
      }

      // Process country
      if (formData.country && formData.country.value) {
        formData.country = formData.country.value;
      }

      formData.token = token;
      submitRFQForm(this.config.serviceUrl, formData)
        .then(response => {
          if (response.status === 200) {
            Storage.removeLocalStorage(StorageKeys.ARTICLE_DATA);
            window.open(this.config.thankyouUrl, "_self");
          } else {
            this.serverError = true;
          }
        })
        .catch(error => {
          this.serverError = true;
          console.error(error);
        });
    }
  }
};
</script>

<style module lang="scss">
@import "./RFQForm.scss";
</style>
